export default __webpack_public_path__ + "static/media/corner_rounded.d41e02f6.svg";